import { render, staticRenderFns } from "./ProductCustomFilters.vue?vue&type=template&id=7fab48d4"
import script from "./ProductCustomFilters.vue?vue&type=script&lang=js"
export * from "./ProductCustomFilters.vue?vue&type=script&lang=js"
import style0 from "./ProductCustomFilters.vue?vue&type=style&index=0&id=7fab48d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports